<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div
        class="form-control-container"
        [ngClass]="{
            'ng-invalid':
                formField.isRequired &&
                formService.isSubmitted &&
                (!formField.valueModel || !formField.valueModel.length),
        }">
        @for (valueModel of formField.possibleValues; track valueModel.id; let index = $index) {
            <label class="checkbox__label checkbox__label--margin-bottom-15px">
                {{ valueModel.value }}
                <input
                    type="checkbox"
                    id="form-element-{{ formField.id }}-{{ index }}"
                    name="formField{{ formField.id }}-{{ index }}"
                    (change)="change()"
                    [(ngModel)]="valueModel.isChecked" />
                <span class="checkbox__checkmark"></span>
            </label>
        }
    </div>
    @if (formService.isSubmitted && formField.isRequired && !formField.valueModel.length) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
